import { render, staticRenderFns } from "./DeclarationValiditySection.vue?vue&type=template&id=20d6bc36&"
import script from "./DeclarationValiditySection.vue?vue&type=script&lang=js&"
export * from "./DeclarationValiditySection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports